import React, { createContext, useState, useEffect, useContext } from 'react';
import { protectedInfos } from '../services/apiSLTP/auth';
import { User } from '../services/apiSLTP/users';
import { QueryClient } from 'react-query';

type AuthContextType = {
    isAuthenticated: boolean;
    login: (user: string) => void;
    logout: () => void;
    user: User | null;
    authIsLoading: boolean;
};

export const AuthContext = createContext<AuthContextType | null>(null);
const queryClient = new QueryClient();

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authIsLoading, setAuthIsLoading] = useState(true);
    const [user, setUser] = useState<User | null>(null);

    const login = (user: string) => {
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.clear();
        queryClient.clear();
        setIsAuthenticated(false);
    };

    const initUsersInfos = async () => {
        try {
            const response = await protectedInfos();
            if (response.data._id) {
                login(response.data.firstName);
                setUser(response.data);
            }
        } catch {
        } finally {
            setAuthIsLoading(false);
        }
    };

    useEffect(() => {
        initUsersInfos();
    }, []);

    return <AuthContext.Provider value={{ isAuthenticated, login, logout, user, authIsLoading }}>{children}</AuthContext.Provider>;
};
